import { ErrorContext } from '@/context/ErrorContext';
import { useContext } from 'react';

export const useErrorHandler = () => useContext(ErrorContext);
